import { useEffect, useState } from "react";
import { toast } from "sonner";
import { IoNotifications, IoNotificationsOffOutline } from "react-icons/io5";
import {
  isStandalone,
  isPushSupported,
  getNotificationPermission,
  subscribeToPush,
  unsubscribeFromPush,
} from "@/push";
import { useI18n } from "@/i18n";
import { NotificationPrefsDialog } from "@/components/NotificationPrefsDialog";

export const NotificationButton = () => {
  const { t } = useI18n();
  const [permission, setPermission] = useState(getNotificationPermission());
  const [busy, setBusy] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const standalone = isStandalone();
  const pushOk = isPushSupported();

  useEffect(() => {
    setPermission(getNotificationPermission());
  }, []);

  const enable = async () => {
    if (!pushOk) {
      toast.info(t("notif_install_first"));
      return;
    }
    if (!standalone) {
      toast.info(t("notif_install_first"));
      return;
    }
    setBusy(true);
    try {
      await subscribeToPush();
      setPermission("granted");
      toast.success(t("notif_enabled"));
    } catch (e) {
      toast.error(e.message || t("notif_failed"));
    } finally {
      setBusy(false);
    }
  };

  const disable = async () => {
    setBusy(true);
    try {
      await unsubscribeFromPush();
      setPermission("default");
      toast.success(t("notif_disabled"));
    } catch {
      toast.error(t("notif_failed"));
    } finally {
      setBusy(false);
    }
  };

  const active = pushOk && permission === "granted";

  return (
    <>
      <button
        data-testid="notif-btn"
        className="tf-icon-btn yellow"
        onClick={() => setDialogOpen(true)}
        disabled={busy}
        aria-label={active ? t("notif_disable") : t("notif_enable")}
        title="Impostazioni notifiche"
      >
        {active ? <IoNotifications size={20} /> : <IoNotificationsOffOutline size={20} />}
      </button>
      <NotificationPrefsDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        pushActive={active}
        pushSupported={pushOk}
        standalone={standalone}
        toggleBusy={busy}
        onToggleSubscription={active ? disable : enable}
      />
    </>
  );
};
